import { toArray } from '../utils/toArray';

function openVideoPopup(node) {
  const embedId = node.dataset.id;
  const start = node.dataset.start;
  let embedSrc = `http://www.youtube.com/watch?v=${embedId}?rel=0&showinfo=0&autohide=1&modestbranding=1${
    start ? `&t=${start}` : ``
  }`;

  $.magnificPopup.open({
    disableOn: 700,
    items: {
      src: embedSrc,
      type: 'iframe'
      // src: $(document.querySelector(`.js-youtube-popup[data-id='${embedId}']`)),
      // type: 'inline'
    },
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false
    // fixedContentPos: false,
    // callbacks: {
    //   open: function() {
    //     $('body').css('overflow', 'hidden');
    //   },
    //   close: function() {
    //     $('body').css('overflow', 'auto');
    //   }
    // }
  });
}

export default () => {
  const youtubePopupLinks = toArray(
    document.querySelectorAll('.js-youtube-popup')
  );

  if (!youtubePopupLinks.length) return;
  youtubePopupLinks.forEach(node => {
    node.addEventListener('click', () => openVideoPopup(node));
  });
};



// WEBPACK FOOTER //
// ./assets/scripts/components/youtube-popup.js